module.exports = __webpack_public_path__ + "static/media/endeavour-energy.4b6b049d.png";